import { useState, useEffect, useRef } from 'react'

interface NetworkStatus {
  isOnline: boolean
  wasOffline: boolean
}

export function useNetworkStatus(): NetworkStatus {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  )
  const [wasOffline, setWasOffline] = useState(false)
  const wasOfflineTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      setWasOffline(true)

      // Clear wasOffline after 3 seconds
      if (wasOfflineTimerRef.current) {
        clearTimeout(wasOfflineTimerRef.current)
      }
      wasOfflineTimerRef.current = setTimeout(() => {
        setWasOffline(false)
      }, 3000)
    }

    const handleOffline = () => {
      setIsOnline(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      if (wasOfflineTimerRef.current) {
        clearTimeout(wasOfflineTimerRef.current)
      }
    }
  }, [])

  return { isOnline, wasOffline }
}
